__turbopack_context__.v({
  "avatar": "K8Spdq_avatar",
  "board": "K8Spdq_board",
  "cardInner": "K8Spdq_cardInner",
  "cardInnerVisible": "K8Spdq_cardInnerVisible",
  "cardSlot": "K8Spdq_cardSlot",
  "cardSlotCollapsed": "K8Spdq_cardSlotCollapsed",
  "chatBubble": "K8Spdq_chatBubble",
  "chatBubbleHead": "K8Spdq_chatBubbleHead",
  "chatBubbleIn": "K8Spdq_chatBubbleIn",
  "chatName": "K8Spdq_chatName",
  "chatTime": "K8Spdq_chatTime",
  "checkbox": "K8Spdq_checkbox",
  "checkboxChecked": "K8Spdq_checkboxChecked",
  "checklistLabel": "K8Spdq_checklistLabel",
  "checklistLabelDone": "K8Spdq_checklistLabelDone",
  "checklistRow": "K8Spdq_checklistRow",
  "colExtra": "K8Spdq_colExtra",
  "cursor": "K8Spdq_cursor",
  "cursorClicking": "K8Spdq_cursorClicking",
  "cursorGlyph": "K8Spdq_cursorGlyph",
  "cursorVisible": "K8Spdq_cursorVisible",
  "elbow": "K8Spdq_elbow",
  "floatCard": "K8Spdq_floatCard",
  "floatCardHeader": "K8Spdq_floatCardHeader",
  "floatCardMeta": "K8Spdq_floatCardMeta",
  "floatCardName": "K8Spdq_floatCardName",
  "floatStack": "K8Spdq_floatStack",
  "nameText": "K8Spdq_nameText",
  "notifyIcon": "K8Spdq_notifyIcon",
  "row": "K8Spdq_row",
  "rowName": "K8Spdq_rowName",
  "rowTag": "K8Spdq_rowTag",
  "rowsBody": "K8Spdq_rowsBody",
  "statSub": "K8Spdq_statSub",
  "stats": "K8Spdq_stats",
  "tableGrid": "K8Spdq_tableGrid",
  "urenAmount": "K8Spdq_urenAmount",
  "urenBooked": "K8Spdq_urenBooked",
  "urenUnit": "K8Spdq_urenUnit",
  "urenValue": "K8Spdq_urenValue",
});
